import { Btn, H6, H2, H3, LI, P, UL, H4 } from '../../../../AbstractElements';
import { MarginBottom, Renew, RenewSubscription, Subscribe, Upgrade, Upgradenow, month } from '../../../../Constant';
import React, { Fragment, useEffect, useState } from 'react';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { getMasterDataToken, postMasterToken } from '../../../../Utils/restUtils';
import { getPackageDet, postSubscription } from '../../../../CommonUrl';
import { useNavigate } from 'react-router';
import HandleHomePageError from '../../../Common/ErrorImport/SignError';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setSubStatus, setSubscriptionDetails } from '../../../../Redux/Reducer';
import { Carousel } from 'react-bootstrap';

import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const Standards = (props) => {
    const priceDetails = props.details;
    const authState = props.auth;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false);
    const [color, setcolor] = useState('');




    useEffect(() => {

        if (priceDetails?.subscription_days_left >= -10 && priceDetails?.subscription_days_left <= 1) {
            setcolor('red')
        } else if (priceDetails?.subscription_days_left <= 10) {
            setcolor('orange')
        } else {
            setcolor('blue')
        }
    }, [])


    const submitSubscription = async (item) => {
        setloading(true);
        const integerNumber = Math.floor(item.price);
        if (integerNumber === 0) {
            const postRequest = { package_id: item.id, industry_type_id: authState.industryId, company_id: props.companyId, company: '' }
            const response = await postMasterToken(postSubscription, postRequest);
            if (response.status === 200) {
                const response = await getMasterDataToken(getPackageDet);
                if (response.status === true) {
                    const packagetDetails = { packageName: response.data.package_name, packageExp: response.data.package_expire_in }
                    dispatch(setSubscriptionDetails(packagetDetails));
                    dispatch(setSubStatus(packagetDetails));
                    if (authState.subStatus !== null || authState.subStatus.length !== 0) {
                        navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                    }
                    toast.success(response.data.message);
                }
                else {
                    HandleHomePageError(navigate, response.status)
                    setloading(false)

                }
                setloading(false)
            }
            else {
                HandleHomePageError(navigate, response.status)
            }
        } else {
            navigate('/applyCoupon', { state: { package_id: item, company_id: props.companyId } });
        }
        setloading(false);
    }


    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <CardBody className='pt-2'>
                {priceDetails?.current_plan != 'None' && (
                    <div>
                        <div className={`mb-3 p-3 text-white bg-subscription-${color} `} >
                            {props.upgradeText && <div><strong>{props.upgradeText}</strong><br /></div>}
                            {
                                priceDetails?.subscription_days_left > 0 ?
                                    <>
                                        <strong>Note:</strong><span>Your current package ends on</span>  <span className="note-date">{priceDetails?.subscription_end_date ?? ''}</span>.{priceDetails?.subscription_days_left < 30 && <span className="note-days-left"> Only {priceDetails?.subscription_days_left ?? ''} days left.</span>}
                                    </>
                                    :
                                    <>
                                        <strong>Note:</strong><span>Your current package has been expired</span>
                                    </>

                            }
                        </div>
                    </div>
                )}

                <Swiper

                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    breakpoints={{
                        40: {
                            slidesPerView: 1, // mobile
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2, // tablet
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3, // small desktop
                            spaceBetween: 40,
                        },
                        1680: {
                            slidesPerView: 4, // large desktop
                            spaceBetween: 60,
                        },
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    // loop={true}
                    navigation
                    pagination={{ clickable: true }}
                >
                    <Row className="pricing-content pricing-col ">
                        {
                            priceDetails?.packages.map((item, index) => {
                                const integerNumber = Math.floor(item.price);
                                const features = item?.features?.split('\n')
                                return (
                                    <SwiperSlide key={index}>

                                        <div key={index}>
                                            <Card className="pricing-block mt-3" style={{ background: '#eff3f9' }}>
                                                <div className="pricing-header text-center">
                                                    <H2>{item.name}</H2>
                                                    <div className="price-box">
                                                        <div>
                                                            {integerNumber !== 0 &&
                                                                <span style={{ textDecoration: 'line-through', color: 'white' }}>{item?.currency}{item.mrp}</span>
                                                            }
                                                            <H3>{item?.currency}{item.price}</H3>
                                                            {/* <P>{item.price_calculation === 'per_unit' ? 'Per connection' : item.price_calculation}</P> */}
                                                            <P>{integerNumber !== 0 && '/Year'}</P>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pricing-list subscription-features d-flex flex-column" style={{ height: 'auto' }} >
                                                    {/* {integerNumber !== 0 && <H4 attrH4={{ style: { color: '#534686' } }}>Setup Cost {authState.currency + item.setup_cost}</H4>} */}
                                                    <UL className='simple-list pricing-inner' >

                                                        {
                                                            features?.map((feature, index) => (

                                                                <li className='my-3' key={index}><H6 className='text-blak' style={{ fontSize: '16px' }} attrH6={{ style: { display: 'flex' } }}>{index + 1}. <span style={{ color: '#534686' }}  > {feature} </span></H6></li>
                                                            ))
                                                        }

                                                        <li className='my-3'><H6 attrH6={{ style: { display: 'flex' } }}>{features?.length + 1 || 1}. <span style={{ color: '#534686' }}>Duration&nbsp;</span> {item.duration} <span style={{ color: '#534686' }}>days</span></H6></li>
                                                        <li className='my-3' ><H6 attrH6={{ style: { display: 'flex' } }}>{features?.length + 2 || 2}. {item.sms === 'off' ? <span style={{ textDecoration: 'line-through', color: '#534686' }}>SMS</span> : ' SMS'}</H6></li>
                                                        <li className='my-3'><H6 attrH6={{ style: { display: 'flex' } }}>{features?.length + 3 || 3}.<span style={{ color: '#534686' }}>Max Service Account&nbsp;</span>{item.max_connection}</H6></li>
                                                        {/* {integerNumber === 0 &&
                                                } */}
                                                    </UL>
                                                    {/* <Btn attrBtn={{ className: 'btn btn-lg ', color: 'primary', size: 'lg',onClick: () => submitSubscription(item) }}>{Subscribe}</Btn> */}
                                                </div>
                                                <div style={{ textAlign: 'center', marginTop: '20px', paddingBottom: '20px', }}>
                                                    {
                                                        priceDetails?.current_plan === 'None' ?
                                                            <button className='btn btn-lg btn-primary' onClick={() => submitSubscription(item)}
                                                            // disabled={priceDetails?.current_plan != 'Free Trial' && priceDetails?.days_left >= 5}
                                                            >{Subscribe}</button> :
                                                            <button
                                                                disabled={priceDetails?.subscription_days_left >= 30 && item?.id === priceDetails?.current_plan_id}
                                                                className='btn btn-lg btn-primary'
                                                                onClick={() => submitSubscription(item)}
                                                            >
                                                                {
                                                                    item?.id === priceDetails?.current_plan_id
                                                                        ? (priceDetails?.subscription_days_left >= 30 ? 'Current Plan' : 'Renew')
                                                                        : 'Upgrade'
                                                                }
                                                            </button>


                                                    }
                                                </div>
                                            </Card>
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Row>


                </Swiper>
            </CardBody>
        </Fragment>
    );
};
export default Standards;